/**
 * Ephemeral "new release" badge helper.
 *
 * Add a slug → expiry-date entry here when a novel is published; the badge
 * automatically disappears from the site once the expiry date is past.
 *
 * Format: expiry date in ISO YYYY-MM-DD (visitor local time).
 */
const NEW_UNTIL = {
  "meadows-t1-dereglement-climatique": "2027-02-23",
  "meadows-t2-last-limit": "2027-02-23",
};

export function isNovelNew(slug) {
  const until = NEW_UNTIL[slug];
  if (!until) return false;
  const now = new Date();
  const end = new Date(`${until}T23:59:59`);
  return !Number.isNaN(end.getTime()) && now < end;
}
